import Stack from '@mui/material/Stack';
import FindProviderForm from '../providers/FindProviderForm/FindProviderForm';
import {useGetProvidersQuery} from '../../redux/services/providerApi';

const ChooseProviderScreen = props => {
  const {
    providerFilters = {},
    width = null,
  } = props;
  const {
    data: providers,
    isLoading,
  } = useGetProvidersQuery(
    {...providerFilters, is_hidden: false},
    { skip: false });
  if (isLoading) return <div>Loading...</div>
  if (!providers) return <div>Missing providers!</div>
  return (
    <Stack alignItems='center' width={width}>
      <FindProviderForm {...props}/>
    </Stack>
  );
};

export default ChooseProviderScreen;
